// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-title {
    margin-left:15%
}

.form-section {
    border: 4px solid var(--hydros-blue);
    border-radius: 10px;
    padding: 10px;
    padding-left: 20px;
    padding-right: 15px;
    margin-left:15%;
    margin-right:15%;
    width: 70%;
    margin-bottom: 20px;
}

.form-section-title {
    font-size: 22px;
    font-weight: bold;
    color: var(--hydros-blue);
    margin-left: -10px;
    margin-bottom: 10px;
}

.submit-button {
    height: 45px;
    width: 40%;
    margin-left: 30%;
    margin-bottom: 25px;
    border-radius: 15px;
    cursor: pointer;
    background-color: var(--hydros-orange);
    transition: background-color 0.5s ease;
    color: white;
    font-weight: 600;
    font-size: 18px;
    border: none;
}
/* Menu déroulant avec barre de défilement */
.consequences-list {
    margin-top: 15px;
    padding: 10px;
    border: 2px solid var(--hydros-orange);
    border-radius: 10px;
    background-color: var(--hydros-sand);
    max-height: 300px; /* Limite la hauteur pour permettre le défilement */
    overflow-y: auto; /* Ajoute la barre de défilement */
  }
  
  /* Style des items de conséquences dans le menu, similaire à .input */
  .consequence-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    border: 2px solid var(--hydros-orange);
    border-radius: 10px;
    width: calc(100% - 20px); /* Calculer la largeur en fonction du padding */
    background-color: white; /* Fond blanc comme l'input */
    font-size: 18px; /* Taille du texte similaire à .input */
  }
  
  /* Titre de chaque conséquence */
  .consequence-title {
    font-size: 18px;
    font-weight: bold;
  }
  
  /* Boutons pour ajouter les conséquences */
  .select-consequence-button {
    padding: 8px 15px;
    margin-left: 10px;
    border-radius: 10px;
    cursor: pointer;
    border: none;
    font-size: 14px;
    transition: background-color 0.3s ease;
  }
  
  .select-consequence-button:first-of-type {
    background-color: var(--hydros-orange);
    color: white;
  }
  
  .select-consequence-button:last-of-type {
    background-color: var(--hydros-sand);
    color: var(--hydros-blue);
  }
  
  .select-consequence-button:hover {
    background-color: darken(var(--hydros-blue), 10%);
  }


/* Liste des conséquences sélectionnées */
.selected-consequences-list {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: 15px;
  }
  
  .selected-consequence-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    background-color: var(--hydros-blue);
    color: white;
    margin-bottom: 10px;
  }
  
  /* Bouton pour supprimer une conséquence */
  .remove-consequence-button {
    padding: 5px 10px;
    border-radius: 8px;
    background-color: var(--hydros-orange);
    color: white;
    border: none;
    cursor: pointer;
  }
  
  .remove-consequence-button:hover {
    background-color: darken(var(--hydros-orange), 10%);
  }  


  /* Zone de dépôt d'image */
.dropzone {
    border: 2px dashed var(--hydros-orange); /* Bordure en pointillés orange */
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    background-color: var(--hydros-sand); /* Fond léger */
    transition: background-color 0.3s ease;
    cursor: pointer;
  }
  
  /* Lorsque l'utilisateur est en train de faire glisser un fichier dans la zone */
  .dropzone.active {
    background-color: var(--hydros-orange-light); /* Couleur plus claire au survol */
  }
  
  /* Texte du label dans la zone de dépôt */
  .dropzone-label {
    font-size: 18px;
    color: var(--hydros-blue);
    cursor: pointer;
  }
  
  /* Indicateur de chargement */
  .loading-indicator {
    margin-top: 10px;
    font-size: 16px;
    color: var(--hydros-blue);
  }
  
  /* Bouton de suppression de l'image */
  .remove-button {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: var(--hydros-orange);
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .remove-button:hover {
    background-color: darken(var(--hydros-orange), 10%);
  }
  
  /* Input file masqué */
  .input-file {
    display: none; /* Masque l'input file natif */
  }
  
  /* Ajoute de la fluidité lors du drag and drop */
  .dropzone.dragover {
    border-color: var(--hydros-blue); /* Change la couleur de la bordure lors du drag */
  }

  /* Section des économies d'eau */
.water-saving-section {
    margin-top: 20px;
  }
  
  .water-saving-title {
    font-size: 22px;
    color: var(--hydros-blue);
    margin-bottom: 15px;
  }
  
  /* Container pour chaque année */
  .water-saving-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px;
    background-color: var(--hydros-sand);
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  /* Label pour chaque année */
  .input-label {
    font-size: 18px;
    margin-right: 20px;
    color: var(--hydros-blue);
  }
  
  /* Container pour le slider */
  .slider-container {
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  /* Style du slider (curseur pour chaque année) */
  .water-saving-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    background: var(--hydros-orange);
    border-radius: 5px;
    outline: none;
    margin-right: 10px;
    transition: background-color 0.3s ease;
  }
  
  /* Style pour le curseur (thumb) */
  .water-saving-slider::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    background-color: var(--hydros-blue);
    border-radius: 50%;
    cursor: pointer;
    -webkit-transition: background-color 0.3s ease;
    transition: background-color 0.3s ease;
  }
  
  .water-saving-slider::-webkit-slider-thumb:hover {
    background-color: var(--hydros-orange);
  }
  
  /* Affichage de la valeur à côté du slider */
  .water-saving-value {
    font-size: 16px;
    color: var(--hydros-blue);
    font-weight: bold;
  }

  /* Section globale */
.concerned-actors-section {
    margin-top: 20px;
  }
  
  /* Titre de la section */
  .section-title {
    font-size: 22px;
    color: var(--hydros-blue);
    margin-bottom: 15px;
  }
  
  /* Carte pour chaque acteur */
  .actor-impact-card {
    background-color: var(--hydros-sand);
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
  }
  
  /* Conteneur pour la sélection de l'acteur */
  .actor-input-container,
  .impact-input-container,
  .financial-impact-container {
    margin-bottom: 10px;
  }
  
  /* Sélecteur d'acteurs */
  .actor-select,
  .financial-select {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 2px solid var(--hydros-orange);
    border-radius: 8px;
  }
  
  /* Input pour les détails */
  .detail-input {
    margin-top: 10px;
    padding: 10px;
    border: 2px solid var(--hydros-orange);
    border-radius: 8px;
    width: calc(100% - 22px); /* Ajustement de la largeur */
  }
  
  /* Conteneur pour les boutons radio (Impact) */
  .radio-group {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }
  
  /* Style pour chaque bouton radio */
  .radio-label {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  
  .radio-label input {
    margin-right: 8px;
  }
  
  /* Bouton pour ajouter un nouvel impact */
  .add-button {
    background-color: var(--hydros-blue);
    color: white;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
    margin-top: 15px;
  }
  
  .add-button:hover {
    background-color: rgb(19, 109, 157);
  }

  /* Bouton pour supprimer un acteur */
.remove-actor-button {
    background-color: #ff4d4d; /* Rouge clair */
    color: white;
    padding: 10px 15px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px; /* Pour espacer du reste */
  }
  
  .remove-actor-button:hover {
    background-color: #ff1a1a; /* Rouge plus foncé au survol */
  }


  .source-input-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .source-input {
    flex: 1 1; /* Permet à l'input de prendre toute la largeur disponible */
    font-size: 18px;
    padding: 10px;
    margin-right: 10px; /* Espacement à droite pour le bouton */
    border: 2px solid var(--hydros-orange);
    border-radius: 10px;
  }
  
  .remove-button {
    height: 45px;
    border-radius: 10px;
    background-color: var(--hydros-orange);
    color: white;
    font-weight: 600;
    font-size: 16px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .remove-button:hover {
    background-color: darkorange; /* Change la couleur au survol */
  }
  .radio-group {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .radio-input {
    display: none; /* Masquer l'input radio natif */
  }
  
  .radio-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border: 2px solid var(--hydros-orange);
    border-radius: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    font-size: 16px;
    font-weight: 600;
  }
  
  .radio-input:checked + .radio-label {
    background-color: var(--hydros-orange);
    color: white;
  }
  
  .radio-input:focus + .radio-label {
    box-shadow: 0 0 5px var(--hydros-orange);
  }

  .button-consequence-section {
    min-width: 400px;
    display: flex;
    flex-direction: row;
  }
  
.consequence-section-decision {
  font-size: 15px;
  padding: 10px;
  padding-left: 25px;
  padding-right: 15px;
  margin-bottom: 20px;
  border: 2px solid var(--hydros-blue);
  border-radius: 10px;
  background-color: white;
}

.decision-container {
  background-color: #fdedc499;
  padding: 10px;
  padding-top: 2px;
  padding-left: 15px;
  padding-right: 20px;
  border-radius: 20px;
  margin-bottom: 5px;
}

.decision-top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.checkbox-container {
  display: flex;
  gap: 10px;
}

.round-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.round-checkbox input {
  margin-right: 5px;
  width: 16px;
  height: 16px;
}

.round-checkbox label {
  font-size: 14px;
  color: #333;
}

input[type="checkbox"]:checked + label {
  color: var(--hydros-blue);
  font-weight: bold;
}

input[type="checkbox"] {
  accent-color: var(--hydros-blue); /* Couleur personnalisée pour la case cochée */
}


.search-bar {
  margin: 10px 0;
}

.search-bar input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.tag-filter {
  margin: 10px 0;
}

.tag-filter select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}


.button-consequence-section {
  margin-top: 10px;
}

.select-consequence-button {
  margin-right: 10px;
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.select-consequence-button:hover {
  background-color: #0056b3;
}


.decision-list-dropdown {
  position: relative;
  width: 100%;
}

.decision-list-search-bar {
  margin: 10px 0;
}

.decision-list-search-bar input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.decision-list-tag-filter {
  margin: 10px 0;
}

.decision-list-tag-filter select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.decision-list-items {
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.decision-list-item {
  padding: 10px;
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
}

.decision-list-item:hover {
  background-color: #f0f0f0;
}



.other-consequences-section {
  margin: 20px 0;
}

.other-consequences-input {
  position: relative;
  display: flex;
  align-items: center;
}

.other-consequences-search {
  padding: 8px;
  width: 500px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dropdown-arrow {
  cursor: pointer;
  padding: 0 10px;
  background-color: hydros-blue;
  color: white;
  border-radius: 0 4px 4px 0;
}

.other-consequences-suggestions {
  max-height: 150px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  position: absolute;
  top: 40px;
  width: 100%;
  z-index: 1000;
  padding: 0;
}

.other-consequences-item {
  padding: 10px;
  cursor: pointer;
  list-style-type: none;
  background-color: white;
}

.other-consequences-item:hover {
  background-color: #f0f0f0;
}

.other-consequences-add-button {
  margin-left: 10px;
  padding: 8px 12px;
  background-color: var(--hydros-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.other-consequences-add-button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.other-consequences-list {
  margin-top: 20px;
}

.other-consequences-selected-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.other-consequences-round-select {
  margin-left: 10px;
  padding: 5px;
}

.other-consequences-remove-button {
  margin-left: 20px;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
}

.other-consequences-header-section {
  display: flex;
  width: 100%;
  justify-content: space-around;

}



.actor-custom-section {
  margin: 20px 0;
}

.actor-custom-input {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.actor-custom-select {
  margin-right: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.actor-custom-name-input {
  margin-right: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.actor-custom-add-button {
  padding: 8px 12px;
  background-color: hydros-orange;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.actor-custom-add-button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.actor-custom-list {
  margin-top: 20px;
}

.actor-custom-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.actor-custom-remove-button {
  margin-left: 10px;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
}



.custom-intro-section {
  margin: 20px 0;
}

.custom-intro-title {
  font-size: 1.5em;
  font-weight: bold;
}

.custom-intro-group {
  margin-bottom: 15px;
}

.custom-intro-input {
  padding: 8px;
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.custom-intro-add-button {
  margin-left: 10px;
  padding: 8px 12px;
  background-color: var(--hydros-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.custom-intro-add-button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.custom-intro-img-list {
  margin-top: 20px;
}

.custom-intro-img-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
}

.custom-intro-remove-button {
  margin-left: 10px;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
}



.game-config-list-container {
  padding: 20px;
}

.game-config-list-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.game-config-list-blue-button {
  height: 45px;
  padding: 0px 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-blue);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.game-config-list-blue-button:hover {
  background-color: var(--hydros-mid-blue);
}

.game-config-list {
  list-style-type: none;
  padding: 0;
}

.game-config-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.game-config-list-name {
  font-size: 18px;
  font-weight: 600;
}

.game-config-list-orange-button {
  height: 45px;
  padding: 0 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-orange);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.game-config-list-orange-button:hover {
  background-color: #faa08a;
}


.decision-list-container {
  padding: 20px;
}

.decision-list-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.game-config-list-blue-button {
  height: 45px;
  padding: 0px 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-blue);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.game-config-list-blue-button:hover {
  background-color: var(--hydros-mid-blue);
}

.decision-list {
  list-style-type: none;
  padding: 0;
}

.decision-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.decision-list-name {
  font-size: 18px;
  font-weight: 600;
}

.decision-list-orange-button {
  height: 45px;
  padding: 0 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-orange);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.decision-list-orange-button:hover {
  background-color: #faa08a;
}


.consequence-list-container {
  padding: 20px;
}

.consequence-list-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.game-config-list-blue-button {
  height: 45px;
  padding: 0px 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-blue);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.game-config-list-blue-button:hover {
  background-color: var(--hydros-mid-blue);
}

.consequence-list {
  list-style-type: none;
  padding: 0;
}

.consequence-list-item {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.consequence-list-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.consequence-list-item-label {
  display: flex;

}

.consequence-language-label {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
  background-color: #4caf50;
  margin-right: 5px;
}

.label-fr {
  background-color: #8e83c3;
}

.label-en {
  background-color: #aa8c67;
}


.consequence-tags {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

/* Style général pour chaque tag */
.consequence-tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
  background-color: #4caf50;
}

.consequence-list-name {
  font-size: 18px;
  font-weight: 600;
}

.consequence-list-orange-button {
  height: 45px;
  padding: 0 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-orange);
  transition: background-color 0.5s ease;
  color: white;
}

.consequence-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.consequence-filter-search {
  flex: 1 1;
  padding: 8px;
  font-size: 16px;
}

.consequence-filter-language {
  padding: 8px;
  font-size: 16px;
}

.consequence-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.consequence-tag-filter {
  display: flex;
  align-items: center;
  gap: 4px;
}



.tag-selector {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tag-input-group {
  display: flex;
  position: relative;
}

.tag-input {
  padding: 8px;
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.tag-add-button {
  margin-left: 10px;
  padding: 8px 12px;
  background-color: hydros-orange;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tag-suggestions {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  max-height: 150px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow-y: auto;
  z-index: 1000;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-suggestion-item {
  background-color: #e0f7fa;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  display: inline-block;
  margin: 4px;
}

.tag-suggestion-item:hover {
  background-color: #b2ebf2;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  background-color: #00796b;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
}

.tag-remove-button {
  background: none;
  border: none;
  color: red;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
}


.message-box {
  padding: 10px;
  margin-bottom: 10px;
  color: white;
  background-color: #4caf50; /* Couleur de succès par défaut */
  border-radius: 4px;
  margin-left: 15%;
  margin-right: 15%;
  width: 70%;
}

.message-box.error {
  background-color: #f44336; /* Couleur d'erreur */
}


.submit-button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.back-button {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: hydros-blue;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}








`, "",{"version":3,"sources":["webpack://./src/form.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;AACA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB,EAAE,mDAAmD;IACtE,gBAAgB,EAAE,kCAAkC;EACtD;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,wBAAwB,EAAE,+CAA+C;IACzE,uBAAuB,EAAE,6BAA6B;IACtD,eAAe,EAAE,uCAAuC;EAC1D;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,0CAA0C;EAC1C;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,iDAAiD;EACnD;;;AAGF,yCAAyC;AACzC;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mDAAmD;EACrD;;;EAGA,0BAA0B;AAC5B;IACI,uCAAuC,EAAE,iCAAiC;IAC1E,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,oCAAoC,EAAE,eAAe;IACrD,sCAAsC;IACtC,eAAe;EACjB;;EAEA,gFAAgF;EAChF;IACE,4CAA4C,EAAE,kCAAkC;EAClF;;EAEA,yCAAyC;EACzC;IACE,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,mDAAmD;EACrD;;EAEA,sBAAsB;EACtB;IACE,aAAa,EAAE,8BAA8B;EAC/C;;EAEA,gDAAgD;EAChD;IACE,gCAAgC,EAAE,iDAAiD;EACrF;;EAEA,gCAAgC;AAClC;IACI,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA,gDAAgD;EAChD;IACE,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA,kCAAkC;EAClC;IAEE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,8CAAsC;IAAtC,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA,4CAA4C;EAC5C;IACE,eAAe;IACf,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA,oBAAoB;AACtB;IACI,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,eAAe;IACf,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,6BAA6B;EAC7B;IACE,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA,4CAA4C;EAC5C;;;IAGE,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;IACf,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,wBAAwB,EAAE,6BAA6B;EACzD;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,yCAAyC;EACzC;IACE,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;EACrC;;EAEA,oCAAoC;AACtC;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;EAC5D;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAO,EAAE,4DAA4D;IACrE,eAAe;IACf,aAAa;IACb,kBAAkB,EAAE,uCAAuC;IAC3D,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,4BAA4B,EAAE,gCAAgC;EAChE;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,gCAAgC;EACjD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,uDAAuD;IACvD,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;AAEF;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC,EAAE,8CAA8C;AAClF;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;;AAE/B;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB,EAAE,iCAAiC;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".form-title {\n    margin-left:15%\n}\n\n.form-section {\n    border: 4px solid var(--hydros-blue);\n    border-radius: 10px;\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 15px;\n    margin-left:15%;\n    margin-right:15%;\n    width: 70%;\n    margin-bottom: 20px;\n}\n\n.form-section-title {\n    font-size: 22px;\n    font-weight: bold;\n    color: var(--hydros-blue);\n    margin-left: -10px;\n    margin-bottom: 10px;\n}\n\n.submit-button {\n    height: 45px;\n    width: 40%;\n    margin-left: 30%;\n    margin-bottom: 25px;\n    border-radius: 15px;\n    cursor: pointer;\n    background-color: var(--hydros-orange);\n    transition: background-color 0.5s ease;\n    color: white;\n    font-weight: 600;\n    font-size: 18px;\n    border: none;\n}\n/* Menu déroulant avec barre de défilement */\n.consequences-list {\n    margin-top: 15px;\n    padding: 10px;\n    border: 2px solid var(--hydros-orange);\n    border-radius: 10px;\n    background-color: var(--hydros-sand);\n    max-height: 300px; /* Limite la hauteur pour permettre le défilement */\n    overflow-y: auto; /* Ajoute la barre de défilement */\n  }\n  \n  /* Style des items de conséquences dans le menu, similaire à .input */\n  .consequence-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    margin-bottom: 10px;\n    border: 2px solid var(--hydros-orange);\n    border-radius: 10px;\n    width: calc(100% - 20px); /* Calculer la largeur en fonction du padding */\n    background-color: white; /* Fond blanc comme l'input */\n    font-size: 18px; /* Taille du texte similaire à .input */\n  }\n  \n  /* Titre de chaque conséquence */\n  .consequence-title {\n    font-size: 18px;\n    font-weight: bold;\n  }\n  \n  /* Boutons pour ajouter les conséquences */\n  .select-consequence-button {\n    padding: 8px 15px;\n    margin-left: 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    border: none;\n    font-size: 14px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .select-consequence-button:first-of-type {\n    background-color: var(--hydros-orange);\n    color: white;\n  }\n  \n  .select-consequence-button:last-of-type {\n    background-color: var(--hydros-sand);\n    color: var(--hydros-blue);\n  }\n  \n  .select-consequence-button:hover {\n    background-color: darken(var(--hydros-blue), 10%);\n  }\n\n\n/* Liste des conséquences sélectionnées */\n.selected-consequences-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-top: 15px;\n  }\n  \n  .selected-consequence-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border-radius: 10px;\n    background-color: var(--hydros-blue);\n    color: white;\n    margin-bottom: 10px;\n  }\n  \n  /* Bouton pour supprimer une conséquence */\n  .remove-consequence-button {\n    padding: 5px 10px;\n    border-radius: 8px;\n    background-color: var(--hydros-orange);\n    color: white;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .remove-consequence-button:hover {\n    background-color: darken(var(--hydros-orange), 10%);\n  }  \n\n\n  /* Zone de dépôt d'image */\n.dropzone {\n    border: 2px dashed var(--hydros-orange); /* Bordure en pointillés orange */\n    border-radius: 15px;\n    padding: 20px;\n    text-align: center;\n    background-color: var(--hydros-sand); /* Fond léger */\n    transition: background-color 0.3s ease;\n    cursor: pointer;\n  }\n  \n  /* Lorsque l'utilisateur est en train de faire glisser un fichier dans la zone */\n  .dropzone.active {\n    background-color: var(--hydros-orange-light); /* Couleur plus claire au survol */\n  }\n  \n  /* Texte du label dans la zone de dépôt */\n  .dropzone-label {\n    font-size: 18px;\n    color: var(--hydros-blue);\n    cursor: pointer;\n  }\n  \n  /* Indicateur de chargement */\n  .loading-indicator {\n    margin-top: 10px;\n    font-size: 16px;\n    color: var(--hydros-blue);\n  }\n  \n  /* Bouton de suppression de l'image */\n  .remove-button {\n    margin-top: 10px;\n    padding: 10px 20px;\n    background-color: var(--hydros-orange);\n    color: white;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .remove-button:hover {\n    background-color: darken(var(--hydros-orange), 10%);\n  }\n  \n  /* Input file masqué */\n  .input-file {\n    display: none; /* Masque l'input file natif */\n  }\n  \n  /* Ajoute de la fluidité lors du drag and drop */\n  .dropzone.dragover {\n    border-color: var(--hydros-blue); /* Change la couleur de la bordure lors du drag */\n  }\n\n  /* Section des économies d'eau */\n.water-saving-section {\n    margin-top: 20px;\n  }\n  \n  .water-saving-title {\n    font-size: 22px;\n    color: var(--hydros-blue);\n    margin-bottom: 15px;\n  }\n  \n  /* Container pour chaque année */\n  .water-saving-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    padding: 10px;\n    background-color: var(--hydros-sand);\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Label pour chaque année */\n  .input-label {\n    font-size: 18px;\n    margin-right: 20px;\n    color: var(--hydros-blue);\n  }\n  \n  /* Container pour le slider */\n  .slider-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n  \n  /* Style du slider (curseur pour chaque année) */\n  .water-saving-slider {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 8px;\n    background: var(--hydros-orange);\n    border-radius: 5px;\n    outline: none;\n    margin-right: 10px;\n    transition: background-color 0.3s ease;\n  }\n  \n  /* Style pour le curseur (thumb) */\n  .water-saving-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 20px;\n    height: 20px;\n    background-color: var(--hydros-blue);\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .water-saving-slider::-webkit-slider-thumb:hover {\n    background-color: var(--hydros-orange);\n  }\n  \n  /* Affichage de la valeur à côté du slider */\n  .water-saving-value {\n    font-size: 16px;\n    color: var(--hydros-blue);\n    font-weight: bold;\n  }\n\n  /* Section globale */\n.concerned-actors-section {\n    margin-top: 20px;\n  }\n  \n  /* Titre de la section */\n  .section-title {\n    font-size: 22px;\n    color: var(--hydros-blue);\n    margin-bottom: 15px;\n  }\n  \n  /* Carte pour chaque acteur */\n  .actor-impact-card {\n    background-color: var(--hydros-sand);\n    padding: 15px;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 15px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Conteneur pour la sélection de l'acteur */\n  .actor-input-container,\n  .impact-input-container,\n  .financial-impact-container {\n    margin-bottom: 10px;\n  }\n  \n  /* Sélecteur d'acteurs */\n  .actor-select,\n  .financial-select {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    border: 2px solid var(--hydros-orange);\n    border-radius: 8px;\n  }\n  \n  /* Input pour les détails */\n  .detail-input {\n    margin-top: 10px;\n    padding: 10px;\n    border: 2px solid var(--hydros-orange);\n    border-radius: 8px;\n    width: calc(100% - 22px); /* Ajustement de la largeur */\n  }\n  \n  /* Conteneur pour les boutons radio (Impact) */\n  .radio-group {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 5px;\n  }\n  \n  /* Style pour chaque bouton radio */\n  .radio-label {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n  }\n  \n  .radio-label input {\n    margin-right: 8px;\n  }\n  \n  /* Bouton pour ajouter un nouvel impact */\n  .add-button {\n    background-color: var(--hydros-blue);\n    color: white;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 100%;\n    margin-top: 15px;\n  }\n  \n  .add-button:hover {\n    background-color: rgb(19, 109, 157);\n  }\n\n  /* Bouton pour supprimer un acteur */\n.remove-actor-button {\n    background-color: #ff4d4d; /* Rouge clair */\n    color: white;\n    padding: 10px 15px;\n    font-size: 16px;\n    font-weight: bold;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 10px; /* Pour espacer du reste */\n  }\n  \n  .remove-actor-button:hover {\n    background-color: #ff1a1a; /* Rouge plus foncé au survol */\n  }\n\n\n  .source-input-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .source-input {\n    flex: 1; /* Permet à l'input de prendre toute la largeur disponible */\n    font-size: 18px;\n    padding: 10px;\n    margin-right: 10px; /* Espacement à droite pour le bouton */\n    border: 2px solid var(--hydros-orange);\n    border-radius: 10px;\n  }\n  \n  .remove-button {\n    height: 45px;\n    border-radius: 10px;\n    background-color: var(--hydros-orange);\n    color: white;\n    font-weight: 600;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .remove-button:hover {\n    background-color: darkorange; /* Change la couleur au survol */\n  }\n  .radio-group {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .radio-input {\n    display: none; /* Masquer l'input radio natif */\n  }\n  \n  .radio-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 20px;\n    border: 2px solid var(--hydros-orange);\n    border-radius: 25px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  \n  .radio-input:checked + .radio-label {\n    background-color: var(--hydros-orange);\n    color: white;\n  }\n  \n  .radio-input:focus + .radio-label {\n    box-shadow: 0 0 5px var(--hydros-orange);\n  }\n\n  .button-consequence-section {\n    min-width: 400px;\n    display: flex;\n    flex-direction: row;\n  }\n  \n.consequence-section-decision {\n  font-size: 15px;\n  padding: 10px;\n  padding-left: 25px;\n  padding-right: 15px;\n  margin-bottom: 20px;\n  border: 2px solid var(--hydros-blue);\n  border-radius: 10px;\n  background-color: white;\n}\n\n.decision-container {\n  background-color: #fdedc499;\n  padding: 10px;\n  padding-top: 2px;\n  padding-left: 15px;\n  padding-right: 20px;\n  border-radius: 20px;\n  margin-bottom: 5px;\n}\n\n.decision-top-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.checkbox-container {\n  display: flex;\n  gap: 10px;\n}\n\n.round-checkbox {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.round-checkbox input {\n  margin-right: 5px;\n  width: 16px;\n  height: 16px;\n}\n\n.round-checkbox label {\n  font-size: 14px;\n  color: #333;\n}\n\ninput[type=\"checkbox\"]:checked + label {\n  color: var(--hydros-blue);\n  font-weight: bold;\n}\n\ninput[type=\"checkbox\"] {\n  accent-color: var(--hydros-blue); /* Couleur personnalisée pour la case cochée */\n}\n\n\n.search-bar {\n  margin: 10px 0;\n}\n\n.search-bar input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.tag-filter {\n  margin: 10px 0;\n}\n\n.tag-filter select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n\n.button-consequence-section {\n  margin-top: 10px;\n}\n\n.select-consequence-button {\n  margin-right: 10px;\n  padding: 8px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.select-consequence-button:hover {\n  background-color: #0056b3;\n}\n\n\n.decision-list-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.decision-list-search-bar {\n  margin: 10px 0;\n}\n\n.decision-list-search-bar input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.decision-list-tag-filter {\n  margin: 10px 0;\n}\n\n.decision-list-tag-filter select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.decision-list-items {\n  margin-top: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.decision-list-item {\n  padding: 10px;\n  border-bottom: 1px solid #eaeaea;\n  cursor: pointer;\n}\n\n.decision-list-item:hover {\n  background-color: #f0f0f0;\n}\n\n\n\n.other-consequences-section {\n  margin: 20px 0;\n}\n\n.other-consequences-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.other-consequences-search {\n  padding: 8px;\n  width: 500px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.dropdown-arrow {\n  cursor: pointer;\n  padding: 0 10px;\n  background-color: hydros-blue;\n  color: white;\n  border-radius: 0 4px 4px 0;\n}\n\n.other-consequences-suggestions {\n  max-height: 150px;\n  overflow-y: auto;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  position: absolute;\n  top: 40px;\n  width: 100%;\n  z-index: 1000;\n  padding: 0;\n}\n\n.other-consequences-item {\n  padding: 10px;\n  cursor: pointer;\n  list-style-type: none;\n  background-color: white;\n}\n\n.other-consequences-item:hover {\n  background-color: #f0f0f0;\n}\n\n.other-consequences-add-button {\n  margin-left: 10px;\n  padding: 8px 12px;\n  background-color: var(--hydros-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.other-consequences-add-button:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.other-consequences-list {\n  margin-top: 20px;\n}\n\n.other-consequences-selected-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.other-consequences-round-select {\n  margin-left: 10px;\n  padding: 5px;\n}\n\n.other-consequences-remove-button {\n  margin-left: 20px;\n  background-color: red;\n  color: white;\n  border: none;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.other-consequences-header-section {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n\n}\n\n\n\n.actor-custom-section {\n  margin: 20px 0;\n}\n\n.actor-custom-input {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.actor-custom-select {\n  margin-right: 10px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.actor-custom-name-input {\n  margin-right: 10px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.actor-custom-add-button {\n  padding: 8px 12px;\n  background-color: hydros-orange;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.actor-custom-add-button:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.actor-custom-list {\n  margin-top: 20px;\n}\n\n.actor-custom-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.actor-custom-remove-button {\n  margin-left: 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n\n\n.custom-intro-section {\n  margin: 20px 0;\n}\n\n.custom-intro-title {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n.custom-intro-group {\n  margin-bottom: 15px;\n}\n\n.custom-intro-input {\n  padding: 8px;\n  width: 250px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.custom-intro-add-button {\n  margin-left: 10px;\n  padding: 8px 12px;\n  background-color: var(--hydros-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.custom-intro-add-button:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.custom-intro-img-list {\n  margin-top: 20px;\n}\n\n.custom-intro-img-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: 5px;\n}\n\n.custom-intro-remove-button {\n  margin-left: 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n\n\n.game-config-list-container {\n  padding: 20px;\n}\n\n.game-config-list-header {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.game-config-list-blue-button {\n  height: 45px;\n  padding: 0px 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-blue);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.game-config-list-blue-button:hover {\n  background-color: var(--hydros-mid-blue);\n}\n\n.game-config-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.game-config-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.game-config-list-name {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.game-config-list-orange-button {\n  height: 45px;\n  padding: 0 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-orange);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.game-config-list-orange-button:hover {\n  background-color: #faa08a;\n}\n\n\n.decision-list-container {\n  padding: 20px;\n}\n\n.decision-list-header {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.game-config-list-blue-button {\n  height: 45px;\n  padding: 0px 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-blue);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.game-config-list-blue-button:hover {\n  background-color: var(--hydros-mid-blue);\n}\n\n.decision-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.decision-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.decision-list-name {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.decision-list-orange-button {\n  height: 45px;\n  padding: 0 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-orange);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.decision-list-orange-button:hover {\n  background-color: #faa08a;\n}\n\n\n.consequence-list-container {\n  padding: 20px;\n}\n\n.consequence-list-header {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.game-config-list-blue-button {\n  height: 45px;\n  padding: 0px 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-blue);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.game-config-list-blue-button:hover {\n  background-color: var(--hydros-mid-blue);\n}\n\n.consequence-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.consequence-list-item {\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.consequence-list-item-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.consequence-list-item-label {\n  display: flex;\n\n}\n\n.consequence-language-label {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: bold;\n  color: white;\n  text-transform: capitalize;\n  background-color: #4caf50;\n  margin-right: 5px;\n}\n\n.label-fr {\n  background-color: #8e83c3;\n}\n\n.label-en {\n  background-color: #aa8c67;\n}\n\n\n.consequence-tags {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n/* Style général pour chaque tag */\n.consequence-tag {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: bold;\n  color: white;\n  text-transform: capitalize;\n  background-color: #4caf50;\n}\n\n.consequence-list-name {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.consequence-list-orange-button {\n  height: 45px;\n  padding: 0 20px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-orange);\n  transition: background-color 0.5s ease;\n  color: white;\n}\n\n.consequence-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.consequence-filter-search {\n  flex: 1;\n  padding: 8px;\n  font-size: 16px;\n}\n\n.consequence-filter-language {\n  padding: 8px;\n  font-size: 16px;\n}\n\n.consequence-filter-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.consequence-tag-filter {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n\n\n.tag-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.tag-input-group {\n  display: flex;\n  position: relative;\n}\n\n.tag-input {\n  padding: 8px;\n  width: 250px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.tag-add-button {\n  margin-left: 10px;\n  padding: 8px 12px;\n  background-color: hydros-orange;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tag-suggestions {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  overflow-y: auto;\n  z-index: 1000;\n  padding: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.tag-suggestion-item {\n  background-color: #e0f7fa;\n  padding: 8px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  display: inline-block;\n  margin: 4px;\n}\n\n.tag-suggestion-item:hover {\n  background-color: #b2ebf2;\n}\n\n.tag-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.tag-item {\n  background-color: #00796b;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.tag-remove-button {\n  background: none;\n  border: none;\n  color: red;\n  font-weight: bold;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n\n.message-box {\n  padding: 10px;\n  margin-bottom: 10px;\n  color: white;\n  background-color: #4caf50; /* Couleur de succès par défaut */\n  border-radius: 4px;\n  margin-left: 15%;\n  margin-right: 15%;\n  width: 70%;\n}\n\n.message-box.error {\n  background-color: #f44336; /* Couleur d'erreur */\n}\n\n\n.submit-button:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.back-button {\n  margin-top: 10px;\n  padding: 8px 12px;\n  background-color: hydros-blue;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
